<template>
    <v-layout>
        <v-navigation-drawer elevation="0" permanent style="height:100vh; position:fixed;
            border: #E9EBF0;  border-right-style: solid; border-width: 1px;">
            <asside-menu />
            <template v-slot:prepend>
                <div class="logo-SVG" style="height: 80px;"></div>
            </template>
            <template v-slot:append>
                <v-divider></v-divider>
                <div class="pa-3 pt-0">
                    <v-btn block rounded="lg" color="#2A1E91" text-color="white" id="Help" name="Help">
                        <svg class="mr-2" width="19" height="19" viewBox="0 0 19 19" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.81838 0.589844C4.89961 0.589844 0.90918 4.57523 0.90918 9.49434C0.90918 14.4181 4.89961 18.4082 9.81834 18.4082C14.7398 18.4082 18.7268 14.4181 18.7268 9.49434C18.7269 4.57523 14.7398 0.589844 9.81838 0.589844ZM10.4532 14.4517C10.2463 14.6358 10.0065 14.7283 9.73487 14.7283C9.45381 14.7283 9.20864 14.6374 8.99937 14.4553C8.78977 14.2735 8.68476 14.019 8.68476 13.692C8.68476 13.4019 8.78638 13.1577 8.98897 12.9598C9.19156 12.7619 9.44007 12.663 9.73487 12.663C10.025 12.663 10.2691 12.7619 10.4674 12.9598C10.6652 13.1577 10.7645 13.4018 10.7645 13.692C10.7641 14.0143 10.6605 14.2676 10.4532 14.4517ZM13.0334 8.05519C12.8744 8.34999 12.6856 8.6042 12.4666 8.81854C12.2482 9.03285 11.8555 9.39305 11.2887 9.89947C11.1324 10.0424 11.0066 10.1678 10.9124 10.2758C10.8182 10.3841 10.7477 10.483 10.7018 10.5729C10.6555 10.6628 10.6199 10.7527 10.5948 10.8426C10.5696 10.9321 10.5317 11.0901 10.4804 11.3158C10.3932 11.7947 10.1192 12.0341 9.6587 12.0341C9.41923 12.0341 9.21801 11.956 9.054 11.7994C8.89065 11.6428 8.80916 11.4103 8.80916 11.1018C8.80916 10.7151 8.86919 10.38 8.98893 10.0967C9.10801 9.81324 9.26731 9.56473 9.4652 9.35042C9.66341 9.13612 9.93036 8.88188 10.2668 8.58707C10.5616 8.32916 10.7745 8.13466 10.9057 8.00349C11.0371 7.87204 11.1475 7.72581 11.237 7.56481C11.3273 7.40349 11.3715 7.22875 11.3715 7.03994C11.3715 6.67137 11.235 6.3608 10.9607 6.10759C10.6867 5.85438 10.3332 5.72759 9.9002 5.72759C9.39344 5.72759 9.02049 5.85537 8.78102 6.11093C8.54155 6.3665 8.33933 6.74279 8.1733 7.24018C8.01635 7.76072 7.71919 8.02094 7.28217 8.02094C7.02425 8.02094 6.8066 7.93005 6.62919 7.74826C6.4521 7.56646 6.36355 7.36961 6.36355 7.15766C6.36355 6.7203 6.50408 6.27692 6.78482 5.82785C7.06588 5.37877 7.47572 5.00681 8.01466 4.71234C8.55327 4.41754 9.18215 4.26995 9.9002 4.26995C10.568 4.26995 11.1572 4.39336 11.6684 4.63989C12.1795 4.88605 12.5746 5.22112 12.8533 5.64502C13.1316 6.0686 13.2711 6.5291 13.2711 7.02649C13.2718 7.41727 13.1923 7.76039 13.0334 8.05519Z"
                                fill="white" />
                        </svg>
                        {{ $t("dashboardLayout.help") }}
                    </v-btn>
                </div>
            </template>
        </v-navigation-drawer>
        <v-app-bar density="compact" elevation="0"
            style="position: fixed; border-color: #E9EBF0;  border-bottom-style: solid; border-bottom-width: 2px; height:72px">
            <nav-bar />
        </v-app-bar>
        <v-main class="layout">
            <v-card flat class="pa-7 mt-3" color="transparent">
                <router-view></router-view>
                <v-snackbar color="success" variant="text" v-model="snackbarSaved" location="top right" timeout=2000
                    class="mt-15 pt-8">
                    <v-alert
                        style="width: fit-content; height: 80px; background: #F6FFFD; border: 3px solid #00CBA0; border-radius: 6.43243px;"
                        variant="outlined">
                        <table>
                            <tr>
                                <span class="AlertTitle">{{ $t("dashboardLayout.save") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.saveAll") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.818 0.650391C8.25908 0.650391 0.469727 8.43974 0.469727 17.9986C0.469727 27.5575 8.25908 35.3468 17.818 35.3468C27.3768 35.3468 35.1662 27.5575 35.1662 17.9986C35.1662 8.43974 27.3768 0.650391 17.818 0.650391ZM26.1104 14.0085L16.274 23.845C16.0311 24.0878 15.7015 24.2266 15.3545 24.2266C15.0075 24.2266 14.6779 24.0878 14.435 23.845L9.5255 18.9354C9.0224 18.4323 9.0224 17.5996 9.5255 17.0965C10.0286 16.5934 10.8613 16.5934 11.3644 17.0965L15.3545 21.0866L24.2715 12.1696C24.7746 11.6665 25.6073 11.6665 26.1104 12.1696C26.6135 12.6727 26.6135 13.4881 26.1104 14.0085Z"
                                    fill="#00CBA0" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarSaved = false" width="36" height="60" viewBox="0 0 36 36" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>
                <v-snackbar color="success" variant="text" v-model="snackbarWarning" location="top right" timeout=2000
                    class="mt-15 pt-8">
                    <v-alert
                        style="width: fit-content; height: 80px; background: #FFFCFC; border: 3px solid #F25C5C; border-radius: 6.43243px;"
                        variant="outlined">
                        <table>
                            <tr>
                                <span class="AlertTitle">{{ $t("dashboardLayout.unableToSave") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.checkDetails") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.818 0.650391C8.25908 0.650391 0.469727 8.43974 0.469727 17.9986C0.469727 27.5575 8.25908 35.3468 17.818 35.3468C27.3768 35.3468 35.1662 27.5575 35.1662 17.9986C35.1662 8.43974 27.3768 0.650391 17.818 0.650391ZM26.1104 14.0085L16.274 23.845C16.0311 24.0878 15.7015 24.2266 15.3545 24.2266C15.0075 24.2266 14.6779 24.0878 14.435 23.845L9.5255 18.9354C9.0224 18.4323 9.0224 17.5996 9.5255 17.0965C10.0286 16.5934 10.8613 16.5934 11.3644 17.0965L15.3545 21.0866L24.2715 12.1696C24.7746 11.6665 25.6073 11.6665 26.1104 12.1696C26.6135 12.6727 26.6135 13.4881 26.1104 14.0085Z"
                                    fill="#F25C5C" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarWarning = false" width="36" height="60" viewBox="0 0 36 36" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>






            <v-snackbar color="success" variant="text" v-model="snackbarImageFailedToSave" location="top right" timeout=2000
                    class="mt-15 pt-8">
                    <v-alert
                        style="width: fit-content; height: 80px; background: #FFFCFC; border: 3px solid #F25C5C; border-radius: 6.43243px;"
                        variant="outlined">
                        <table>
                            <tr>
                                <span class="AlertTitle">{{ $t("dashboardLayout.ImageFailedTitle") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.ImageErrorDetails") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.818 0.650391C8.25908 0.650391 0.469727 8.43974 0.469727 17.9986C0.469727 27.5575 8.25908 35.3468 17.818 35.3468C27.3768 35.3468 35.1662 27.5575 35.1662 17.9986C35.1662 8.43974 27.3768 0.650391 17.818 0.650391ZM26.1104 14.0085L16.274 23.845C16.0311 24.0878 15.7015 24.2266 15.3545 24.2266C15.0075 24.2266 14.6779 24.0878 14.435 23.845L9.5255 18.9354C9.0224 18.4323 9.0224 17.5996 9.5255 17.0965C10.0286 16.5934 10.8613 16.5934 11.3644 17.0965L15.3545 21.0866L24.2715 12.1696C24.7746 11.6665 25.6073 11.6665 26.1104 12.1696C26.6135 12.6727 26.6135 13.4881 26.1104 14.0085Z"
                                    fill="#F25C5C" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarImageFailedToSave = false" width="36" height="60" viewBox="0 0 36 36" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>









                <v-snackbar color="success" variant="text" v-model="snackbarDeleted" location="top right" timeout=2000
                    class="mt-15 pt-8">
                    <v-alert
                        style="width: fit-content; height: 80px; background: #FFF9F5; border: 3px solid #FF8934; border-radius: 6.43243px;"
                        variant="outlined">
                        <table>
                            <tr>
                                <span class="AlertTitle">{{ $t("dashboardLayout.delete") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.saveAll") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M36.553 9.2542C33.76 8.97663 30.9669 8.76845 28.1565 8.61232V8.59497L27.7748 6.3397C27.5146 4.74366 27.1329 2.34961 23.0735 2.34961H18.5282C14.4861 2.34961 14.1044 4.63958 13.8268 6.32235L13.4625 8.54293C11.8492 8.64702 10.2358 8.75111 8.62238 8.90724L5.08334 9.2542C4.35472 9.3236 3.83427 9.96548 3.90366 10.6768C3.97306 11.388 4.59759 11.9085 5.32622 11.8391L8.86526 11.4921C17.9557 10.59 27.1156 10.937 36.3102 11.8564C36.3622 11.8564 36.3969 11.8564 36.4489 11.8564C37.1082 11.8564 37.6807 11.3533 37.7501 10.6768C37.8021 9.96548 37.2817 9.3236 36.553 9.2542Z"
                                    fill="#FF8934" />
                                <path
                                    d="M33.3605 14.3035C32.9442 13.8698 32.3717 13.627 31.7818 13.627H9.85366C9.26383 13.627 8.67399 13.8698 8.27498 14.3035C7.87597 14.7372 7.65044 15.3271 7.68514 15.9343L8.76073 33.7335C8.95156 36.3705 9.19443 39.6666 15.249 39.6666H26.3865C32.4411 39.6666 32.6839 36.3878 32.8748 33.7335L33.9503 15.9516C33.985 15.3271 33.7595 14.7372 33.3605 14.3035ZM23.6975 30.9752H17.9206C17.2093 30.9752 16.6195 30.3853 16.6195 29.6741C16.6195 28.9628 17.2093 28.3729 17.9206 28.3729H23.6975C24.4088 28.3729 24.9987 28.9628 24.9987 29.6741C24.9987 30.3853 24.4088 30.9752 23.6975 30.9752ZM25.1548 24.0359H16.4807C15.7694 24.0359 15.1796 23.446 15.1796 22.7348C15.1796 22.0235 15.7694 21.4337 16.4807 21.4337H25.1548C25.8661 21.4337 26.4559 22.0235 26.4559 22.7348C26.4559 23.446 25.8661 24.0359 25.1548 24.0359Z"
                                    fill="#FF8934" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarDeleted = false" width="36" height="60" viewBox="0 0 36 36" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>
                <v-snackbar color="success" variant="text" v-model="snackbarWarning401" location="top right" timeout=2000
                    class="mt-15 pt-8">
                    <v-alert
                        style="width: fit-content; height: 80px; padding-top: 8px; background: #FFFCFC; border: 3px solid #F25C5C; border-radius: 6.43243px;"
                        variant="outlined">
                        <table>
                            <tr>
                                <span class="AlertTitle">{{ $t("dashboardLayout.unauthorized") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.checkAuthorization") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
                                    fill="#292D32" />
                                <path
                                    d="M8.80974 18.2501C8.73974 18.2501 8.65974 18.2501 8.58974 18.2301L7.39974 18.0701C6.67974 17.9701 6.04974 17.3501 5.93974 16.6101L5.76974 15.4001C5.69974 14.9201 5.89974 14.3101 6.24974 13.9501L8.52974 11.6701C8.18974 10.0501 8.67974 8.37007 9.86974 7.19007C11.7797 5.28007 14.8997 5.28007 16.8097 7.19007C17.7397 8.12007 18.2497 9.35007 18.2497 10.6601C18.2497 11.9701 17.7397 13.2101 16.8097 14.1301C15.6197 15.3101 13.9397 15.8001 12.3297 15.4601L10.0397 17.7401C9.74974 18.0501 9.25974 18.2501 8.80974 18.2501ZM13.3397 7.25007C12.4697 7.25007 11.5897 7.58007 10.9297 8.25007C10.0297 9.15007 9.70974 10.4601 10.0797 11.6801C10.1597 11.9501 10.0897 12.2301 9.88974 12.4301L7.30974 15.0101C7.28974 15.0401 7.24974 15.1501 7.24974 15.1901L7.41974 16.3901C7.42974 16.4501 7.53974 16.5601 7.59974 16.5701L8.79974 16.7401C8.84974 16.7301 8.94974 16.7101 8.97974 16.6801L11.5697 14.0901C11.7697 13.8901 12.0597 13.8301 12.3197 13.9101C13.5297 14.2901 14.8397 13.9701 15.7397 13.0701C16.3797 12.4301 16.7397 11.5701 16.7397 10.6601C16.7397 9.75007 16.3897 8.89007 15.7397 8.25007C15.0897 7.59007 14.2097 7.25007 13.3397 7.25007Z"
                                    fill="#292D32" />
                                <path
                                    d="M10.4493 17.0301C10.2593 17.0301 10.0693 16.9601 9.9193 16.8101L9.0593 15.9501C8.7693 15.6601 8.7693 15.1801 9.0593 14.8901C9.3493 14.6001 9.8293 14.6001 10.1193 14.8901L10.9793 15.7501C11.2693 16.0401 11.2693 16.5201 10.9793 16.8101C10.8393 16.9601 10.6493 17.0301 10.4493 17.0301Z"
                                    fill="#292D32" />
                                <path
                                    d="M13.3791 11.8001C13.2391 11.8001 13.1091 11.7801 12.9891 11.7301C12.8691 11.6801 12.7591 11.6001 12.6691 11.5101C12.4791 11.3201 12.3691 11.0701 12.3691 10.8001C12.3691 10.5401 12.4791 10.2801 12.6691 10.1001C12.8991 9.86012 13.2491 9.75012 13.5691 9.82012C13.6291 9.84012 13.6991 9.85012 13.7591 9.88012C13.8191 9.91012 13.8791 9.94012 13.9291 9.97012C13.9791 10.0101 14.0391 10.0501 14.0791 10.1001C14.2691 10.2801 14.3791 10.5401 14.3791 10.8001C14.3791 10.9401 14.3491 11.0601 14.2991 11.1901C14.2491 11.3101 14.1791 11.4201 14.0791 11.5101C13.8891 11.7001 13.6391 11.8001 13.3791 11.8001Z"
                                    fill="#292D32" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarWarning401 = false" width="36" height="60" viewBox="0 0 36 36" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>
                <v-snackbar color="success" variant="text" v-model="snackbarPurchaseOrderInsufficient" location="top right" timeout=2000 class="mt-15 pt-8">
                    <v-alert 
                        style="width: fit-content; height: 80px; background: #FFFCFC; border: 3px solid #F25C5C; border-radius: 6.43243px;"
                        variant="outlined">
                        <table style="padding-top:0px ;">
                            <tr>
                                <span class="AlertTitle">{{ $t("dashboardLayout.PurchaseOrderInsufficientWarning") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.PurchaseOrderInsufficientDetails") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.818 0.650391C8.25908 0.650391 0.469727 8.43974 0.469727 17.9986C0.469727 27.5575 8.25908 35.3468 17.818 35.3468C27.3768 35.3468 35.1662 27.5575 35.1662 17.9986C35.1662 8.43974 27.3768 0.650391 17.818 0.650391ZM26.1104 14.0085L16.274 23.845C16.0311 24.0878 15.7015 24.2266 15.3545 24.2266C15.0075 24.2266 14.6779 24.0878 14.435 23.845L9.5255 18.9354C9.0224 18.4323 9.0224 17.5996 9.5255 17.0965C10.0286 16.5934 10.8613 16.5934 11.3644 17.0965L15.3545 21.0866L24.2715 12.1696C24.7746 11.6665 25.6073 11.6665 26.1104 12.1696C26.6135 12.6727 26.6135 13.4881 26.1104 14.0085Z" fill="#F25C5C" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarPurchaseOrderInsufficient = false" width="36" height="60" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>
                <v-snackbar color="success" variant="text" v-model="snackbarWarningDeleteRole" location="top right" timeout=2000
                    class="mt-15 pt-8">
                    <v-alert
                    style="width: fit-content; height: 80px; background: #FFFCFC; border: 3px solid #F25C5C; border-radius: 6.43243px;"
                        variant="outlined">
                        <table>
                            <tr>
                                <span class="AlertTitle"> {{ $t("dashboardLayout.unableToDeleteWhenUserExists") }}</span>
                            </tr>
                            <tr>
                                <span class="AlertText">{{ $t("dashboardLayout.checkAuthorizationWhenUserExists") }}</span>
                            </tr>
                        </table>
                        <template v-slot:prepend>
                            <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.818 0.650391C8.25908 0.650391 0.469727 8.43974 0.469727 17.9986C0.469727 27.5575 8.25908 35.3468 17.818 35.3468C27.3768 35.3468 35.1662 27.5575 35.1662 17.9986C35.1662 8.43974 27.3768 0.650391 17.818 0.650391ZM26.1104 14.0085L16.274 23.845C16.0311 24.0878 15.7015 24.2266 15.3545 24.2266C15.0075 24.2266 14.6779 24.0878 14.435 23.845L9.5255 18.9354C9.0224 18.4323 9.0224 17.5996 9.5255 17.0965C10.0286 16.5934 10.8613 16.5934 11.3644 17.0965L15.3545 21.0866L24.2715 12.1696C24.7746 11.6665 25.6073 11.6665 26.1104 12.1696C26.6135 12.6727 26.6135 13.4881 26.1104 14.0085Z"
                                    fill="#F25C5C" />
                            </svg>
                        </template>
                        <template v-slot:append>
                            <svg @click="snackbarWarning = false" width="36" height="60" viewBox="0 0 36 36" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="0.989605"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13.6249 4.67188L4.96582 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.96582 4.67188L13.6249 13.3309" stroke="#080C3E" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </template>
                    </v-alert>
                </v-snackbar>
                
            </v-card>
        </v-main>
    </v-layout>
</template>
<script>
import AssideMenu from "./AssideMenu.vue";
import NavBar from "./NavBar.vue";
export default {
    name: 'MainLayout',
    components: { NavBar, AssideMenu },
    data: () => ({
        snackbarImageFailedToSave: false,
        snackbarSaved: false,
        snackbarWarning: false,
        snackbarDeleted: false,
        snackbarWarning401: false,
        snackbarWarningDeleteRole: false,
        snackbarPurchaseOrderInsufficient: false
    }),
    methods: {
        ActiveImageFailedToSave() {
            this.snackbarImageFailedToSave = true;
        },
        ActiveSavedSnackBar() {
            this.snackbarSaved = true;
        },
        ActiveWarningSnackBar() {
            this.snackbarWarning = true;
        },
        ActiveDeletedSnackBar() {
            this.snackbarDeleted = true;
        },
        ActiveWarningDeleteRoleSnackBar() {
            this.snackbarWarningDeleteRole = true;
        },
        ActivePurchaseOrderInsufficientSnackBar() {
            this.snackbarPurchaseOrderInsufficient = true;
        }
    },
    created() {
        document.title = window.VUE_APP_NAME
        this.emitter.on('Active401WarningSnackBar', () => {
            this.snackbarWarning401 = true;
        })
    },
};
</script>
<style scoped>
.AlertTitle {
    font-family: 'Manrope';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    color: #080C3E;
    padding-bottom: 0px;
    margin-bottom: 0px;
}

.AlertText {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #667280;
    padding-top: 0px;
    margin-top: 0px;
    white-space: nowrap;
}

.layout {
    min-height: 100vh;
    background-color: #F8FBFF;
}

.v-btn {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;
    text-transform: none;
}
</style>

<style>

.v-alert__content{
    align-self: normal;
}

</style>